import React from 'react';
import { PropRow } from '../activity-drawer/ui/PropRow';

interface ValueRowProps {
  icon: React.ReactNode;
  label: string;
  /** Valore testuale; se assente e senza children mostra "Vuoto". */
  value?: string | null;
  /** Valore custom (chip, badge...): ha precedenza su `value`. */
  children?: React.ReactNode;
  /** Colore link (email, sito). */
  isLink?: boolean;
  onClick?: () => void;
  /** Azioni ghost a destra: hover-only su desktop, sempre visibili su touch. */
  actions?: React.ReactNode;
  /** Il valore va a capo invece di troncare (liste di chip). */
  wrap?: boolean;
}

/** Riga di proprietà read-only del pannello: valore o "Vuoto", azioni all'hover. */
export function ValueRow({ icon, label, value, children, isLink, onClick, actions, wrap }: ValueRowProps) {
  return (
    <PropRow icon={icon} label={label} onClick={onClick} trailing={actions} wrap={wrap}>
      {children ??
        (value ? (
          <span className={`truncate ${isLink ? 'text-[#337EA9] dark:text-[#529CCA]' : ''}`}>{value}</span>
        ) : (
          <span className="text-[rgba(55,53,47,0.45)] dark:text-gray-500">Vuoto</span>
        ))}
    </PropRow>
  );
}
